import i18next from 'i18next';
/**
 * Adapts the `kinderConnectCaptureChildren` query response into the flat shape the capture
 * settings modal's list and filter work with.
 *
 * @param queriedChildren - The query's `kinderConnectCaptureChildren` list.
 * @returns One row per child, with a placeholder room name for a child with no group assigned.
 */
export const adaptKinderConnectCaptureChildrenQueryToSettingsChildren = (queriedChildren) => queriedChildren.map(queriedChild => {
    var _a, _b;
    return ({
        id: queriedChild.id,
        name: queriedChild.child.name.fullName,
        roomName: (_b = (_a = queriedChild.child.group) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings.noRoomLabel),
        captureEnabled: queriedChild.captureRequired,
    });
});
